import {
    Dog, Cat, Bird, Utensils, Smile, Hand,
    Baby, GlassWater, Milk, User, MessageCircle, Gift, Heart,
    Brain, HelpCircle
} from 'lucide-react';

export const AGE_GROUPS = [
    {
        id: '1-3',
        name: 'Exploradores',
        range: '1 a 3 años',
        color: 'bg-[#FFD1DC]',
        textColor: 'text-[#8B5E66]',
        description: 'Primeras palabras y sonidos',
        icon: <Baby size={40} className="text-white" />,
        imagePath: '/imagenes/capy/categorias/exploradores.png'
    },
    {
        id: '4-6',
        name: 'Aventureros',
        range: '4 a 6 años',
        color: 'bg-[#CAF0F8]',
        textColor: 'text-[#5E7E8B]',
        description: 'Juegos de memoria y preguntas',
        icon: <Smile size={40} className="text-white" />,
        imagePath: '/imagenes/capy/categorias/aventureros.png'
    }
];

export const CAPY_CATEGORIES = [
    // 1-3 YEARS (Flashcards)
    {
        id: 'primeras-palabras',
        ageGroup: '1-3',
        gameType: 'flashcard',
        name: 'Primeras Palabras',
        color: 'bg-[#FFD1DC]', // Pastel Peach
        textColor: 'text-[#8B5E66]',
        description: 'Palabras básicas para empezar a hablar.',
        icon: <Smile size={40} className="text-white" />,
        imagePath: '/imagenes/capy/categorias/primeras-palabras.png'
    },
    {
        id: 'animales',
        ageGroup: '1-3',
        gameType: 'flashcard',
        name: 'Animales Divertidos',
        color: 'bg-[#CAF0F8]', // Pastel Blue
        textColor: 'text-[#5E7E8B]',
        description: '¡Conoce a tus amigos peludos y emplumados!',
        icon: <Dog size={40} className="text-white" />,
        imagePath: '/imagenes/capy/categorias/animales.png'
    },
    {
        id: 'buenos-modales',
        ageGroup: '1-3',
        gameType: 'flashcard',
        name: 'Buenos Modales',
        color: 'bg-[#E2F0CB]', // Mint
        textColor: 'text-[#6B7E5E]',
        description: 'Palabras mágicas para ser amable.',
        icon: <Hand size={40} className="text-white" />,
        imagePath: '/imagenes/capy/categorias/buenos-modales.png'
    },

    // 4-6 YEARS (Memory & Quiz)
    {
        id: 'memoria-animales',
        ageGroup: '4-6',
        gameType: 'memory',
        name: 'Memoria Animal',
        color: 'bg-[#FDE2E4]', // Soft Pink
        textColor: 'text-[#8B5E66]',
        description: 'Encuentra las parejas de animalitos.',
        icon: <Brain size={40} className="text-white" />,
        imagePath: '/imagenes/capy/categorias/memoria.png'
    },
    {
        id: 'quiz-que-es',
        ageGroup: '4-6',
        gameType: 'quiz',
        name: '¿Qué es esto?',
        color: 'bg-[#CDDAFD]', // Periwinkle
        textColor: 'text-[#5E5E8B]',
        description: 'Adivina la palabra correcta.',
        icon: <HelpCircle size={40} className="text-white" />,
        imagePath: '/imagenes/capy/categorias/quiz.png'
    }
];

export const CAPY_DATA = [
    // --- 1-3 AÑOS ---
    // Primeras Palabras
    { id: 'mama', categoryId: 'primeras-palabras', word: 'Mamá', imagePath: '/imagenes/capy/palabras/mama.png', Icon: <User size={120} className="text-[#FFD1DC]" />, difficulty: 1 },
    { id: 'papa', categoryId: 'primeras-palabras', word: 'Papá', imagePath: '/imagenes/capy/palabras/papa.png', Icon: <User size={120} className="text-[#CAF0F8]" />, difficulty: 1 },
    { id: 'agua', categoryId: 'primeras-palabras', word: 'Agua', imagePath: '/imagenes/capy/palabras/agua.png', Icon: <GlassWater size={120} className="text-[#CAF0F8]" />, difficulty: 1 },
    { id: 'leche', categoryId: 'primeras-palabras', word: 'Leche', imagePath: '/imagenes/capy/palabras/leche.png', Icon: <Milk size={120} className="text-[#FEF9E7]" />, difficulty: 1 },

    // Animales
    { id: 'perro', categoryId: 'animales', word: 'Perro', sound: '¡Guau guau!', imagePath: '/imagenes/capy/animales/perro.png', audioPath: '/sonidos/capy/ladrido.mp3', Icon: <Dog size={120} className="text-[#E2C2A4]" />, difficulty: 1 },
    { id: 'gato', categoryId: 'animales', word: 'Gato', sound: '¡Miau!', imagePath: '/imagenes/capy/animales/gato.png', audioPath: '/sonidos/capy/maullido.mp3', Icon: <Cat size={120} className="text-[#A2D2FF]" />, difficulty: 1 },
    { id: 'pajaro', categoryId: 'animales', word: 'Pájaro', sound: '¡Pío pío!', imagePath: '/imagenes/capy/animales/pajaro.png', Icon: <Bird size={120} className="text-[#FDE2E4]" />, difficulty: 2 },
    { id: 'vaca', categoryId: 'animales', word: 'Vaca', sound: '¡Muuu!', imagePath: '/imagenes/capy/animales/vaca.png', Icon: <Milk size={120} className="text-[#CDDAFD]" />, difficulty: 2 },

    // Buenos Modales
    { id: 'hola', categoryId: 'buenos-modales', word: 'Hola', imagePath: '/imagenes/capy/modales/hola.png', Icon: <Hand size={120} className="text-[#FFD1DC]" />, difficulty: 1 },
    { id: 'adios', categoryId: 'buenos-modales', word: 'Adiós', imagePath: '/imagenes/capy/modales/adios.png', Icon: <Hand size={120} className="text-[#FFD1DC]" />, difficulty: 1 },
    { id: 'por-favor', categoryId: 'buenos-modales', word: 'Por Favor', imagePath: '/imagenes/capy/modales/por-favor.png', Icon: <Heart size={120} className="text-[#FFC8DD]" />, difficulty: 2 },
    { id: 'gracias', categoryId: 'buenos-modales', word: 'Gracias', imagePath: '/imagenes/capy/modales/gracias.png', Icon: <Gift size={120} className="text-[#BDE0FE]" />, difficulty: 2 },

    // --- 4-6 AÑOS ---
    // Memoria Animales (Usamos los mismos o nuevos pares)
    { id: 'mem-perro', categoryId: 'memoria-animales', word: 'Perro', sound: '¡Guau guau!', imagePath: '/imagenes/capy/memoria/perro.png', pairId: 'pair-perro', Icon: <Dog size={120} className="text-[#E2C2A4]" /> },
    { id: 'mem-gato', categoryId: 'memoria-animales', word: 'Gato', sound: '¡Miau!', imagePath: '/imagenes/capy/memoria/gato.png', pairId: 'pair-gato', Icon: <Cat size={120} className="text-[#A2D2FF]" /> },
    { id: 'mem-pajaro', categoryId: 'memoria-animales', word: 'Pájaro', sound: '¡Pío pío!', imagePath: '/imagenes/capy/memoria/pajaro.png', pairId: 'pair-pajaro', Icon: <Bird size={120} className="text-[#FDE2E4]" /> },
    { id: 'mem-vaca', categoryId: 'memoria-animales', word: 'Vaca', sound: '¡Muuu!', imagePath: '/imagenes/capy/memoria/vaca.png', pairId: 'pair-vaca', Icon: <Milk size={120} className="text-[#CDDAFD]" /> },
    { id: 'mem-caballo', categoryId: 'memoria-animales', word: 'Caballo', sound: '¡Hiii!', imagePath: '/imagenes/capy/memoria/caballo.png', pairId: 'pair-caballo', Icon: <Smile size={120} className="text-[#CDDAFD]" /> },
    { id: 'mem-cerdo', categoryId: 'memoria-animales', word: 'Cerdo', sound: '¡Oink oink!', imagePath: '/imagenes/capy/memoria/cerdo.png', pairId: 'pair-cerdo', Icon: <Dog size={120} className="text-[#E2C2A4]" /> },


    // Quiz ¿Qué es esto?
    {
        id: 'quiz-1', categoryId: 'quiz-que-es', word: 'Perro',
        question: '¿Cuál de estos es un Perro?',
        correctAnswer: 'perro',
        options: [
            { id: 'perro', imagePath: '/imagenes/capy/quiz/perro.png', word: 'Perro' },
            { id: 'gato', imagePath: '/imagenes/capy/quiz/gato.png', word: 'Gato' },
            { id: 'pajaro', imagePath: '/imagenes/capy/quiz/pajaro.png', word: 'Pájaro' },
        ]
    },
    {
        id: 'quiz-2', categoryId: 'quiz-que-es', word: 'Agua',
        question: '¿Qué necesitas para beber cuando tienes sed?',
        correctAnswer: 'agua',
        options: [
            { id: 'leche', imagePath: '/imagenes/capy/quiz/leche.png', word: 'Leche' },
            { id: 'agua', imagePath: '/imagenes/capy/quiz/agua.png', word: 'Agua' },
            { id: 'hola', imagePath: '/imagenes/capy/quiz/hola.png', word: 'Hola' },
        ]
    },
    {
        id: 'quiz-3', categoryId: 'quiz-que-es', word: 'Gracias',
        question: '¿Qué palabra mágica usas cuando te dan un regalo?',
        correctAnswer: 'gracias',
        options: [
            { id: 'adios', imagePath: '/imagenes/capy/quiz/adios.png', word: 'Adiós' },
            { id: 'gracias', imagePath: '/imagenes/capy/quiz/gracias.png', word: 'Gracias' },
            { id: 'por-favor', imagePath: '/imagenes/capy/quiz/por-favor.png', word: 'Por favor' },
        ]
    }
];
